import React from "react";
import { translate } from "Shared/translate";
import Icon from "Shared/Icon";
import classnames from "classnames";
import * as styles from "./base.scss";
import Tooltip from "Shared/Tooltip";
import * as Root from "SiteLayout/Root";
import { favoritePageUrl } from "Shared/known-urls";
import { pathCombine, urlToString } from "Shared/url";
import addRemoveFromListStyles from "Shared/AddRemoveFromList/base.scss";
import { replaceState } from "Shared/history";
class ProductFavoriteMark extends React.Component {
    constructor(props) {
        super(props);
        this.toggleTooltip = (e) => {
            e && e.preventDefault();
            this.setState({ showTooltip: !this.state.showTooltip });
        };
        this.state = {
            showTooltip: false,
        };
    }
    componentDidMount() {
        this.unbindRootClick = Root.on("click", () => {
            if (this.state.showTooltip) {
                this.setState({
                    showTooltip: false,
                });
            }
        });
    }
    componentWillUnmount() {
        this.unbindRootClick && this.unbindRootClick();
    }
    goTo(id) {
        if (!!this.props.onClick) {
            this.props.onClick();
        }
        replaceState(urlToString({
            path: pathCombine(favoritePageUrl().url),
            query: { open: id },
        }));
    }
    render() {
        if (!this.props.list) {
            return null;
        }
        return (React.createElement("div", { className: classnames(styles.wrapper, this.props.extraLarge && !this.props.showText && styles.extraLarge, this.props.showBoth && styles.both, this.props.className) },
            this.state.showTooltip && (React.createElement(Tooltip, { close: this.toggleTooltip, closeButton: true, closeOnClick: false, horizontal: !!this.props.horizontal ? this.props.horizontal : "center", vertical: !!this.props.reverseFavToolbar ? "bottom" : "top" },
                React.createElement("div", { className: styles.tooltip },
                    React.createElement("strong", null, translate("/Product/FavoriteListHeading")),
                    React.createElement("ul", null, Object.keys(this.props.list).map((key) => (React.createElement("li", { key: `Mark${key}` },
                        React.createElement("a", { href: void 0, onClick: () => this.goTo(key) }, this.props.list[key])))))))),
            React.createElement("div", { onClick: this.toggleTooltip, className: styles.icon },
                this.props.showBoth && (React.createElement("div", { className: addRemoveFromListStyles.listAdd },
                    React.createElement("div", { className: classnames(addRemoveFromListStyles.circle, addRemoveFromListStyles.activeIcon) },
                        React.createElement(Icon, { appearance: "sans", name: "heart-filled" })))),
                this.props.showText || this.props.showBoth ? (React.createElement("span", null, translate("/Product/FavoriteList"))) : (React.createElement("div", { className: addRemoveFromListStyles.listAdd },
                    React.createElement("div", { className: classnames(addRemoveFromListStyles.circle, addRemoveFromListStyles.activeIcon) },
                        React.createElement(Icon, { appearance: "sans", name: "heart-filled" })))))));
    }
}
export default ProductFavoriteMark;
